import { makeStyles } from '@material-ui/core/styles';
export var useContentStyles = makeStyles(function (theme) { return ({
    iconClose: {
        fontSize: 24,
        color: theme.palette.common.white,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(2),
        fontSize: 34,
        color: 'inherit',
    },
    message: {
        color: theme.palette.common.white,
        fontWeight: 400,
    },
    content: {
        backgroundColor: theme.palette.grey['900'],
        borderBottomRightRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        color: 'inherit',
        padding: theme.spacing(0.5, 1, 1.5, 2),
    },
}); });
export var useSnackbarStyles = makeStyles(function (theme) { return ({
    root: {
        paddingTop: theme.spacing(0.75),
        borderRadius: theme.shape.borderRadius,
    },
}); });
export var useSnackbarVariantStyles = makeStyles(function (theme) { return ({
    success: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.main,
    },
    info: {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.info.main,
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.main,
    },
}); });
